import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import routes from "routes";
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";
import brand from "assets/images/logo.png";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase/firebase-config";
import Message from "./components/message";
import toast from "react-hot-toast";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { jwtDecode } from "jwt-decode";
import "./style.css";
import SignUp from "layouts/authentication/sign-up";
import { ChangeThemeOnRedux } from "api/commonSlice";
import { useDispatch } from "react-redux";


export default function App() {
  
  const dispatcho = useDispatch();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  onMessage(messaging, (payload) => {
    toast.success(<Message notification={payload.notification} />);
  });



  const navigate = useNavigate();
  const isToken = localStorage.getItem('token');

  useEffect(() => {
    const theme = localStorage.getItem('theme');
    if (theme === 'light') {
      dispatcho(ChangeThemeOnRedux('light'))
      document.body.classList.add('light-mode');
    } else {
      dispatcho(ChangeThemeOnRedux('dark'))
      document.body.classList.add('dark-mode');
    }
  }, []);

  useEffect(() => {
    if(isToken){
    const decodedToken = jwtDecode(isToken);
    const currentTime = Date.now() / 1000;
  }
  }, []);



  useEffect(() => {
    
    if (isToken == null) {
     if(pathname == "/register"){
        return;
     }
     if(pathname == "/forgot-password"){
        return;
     }
      navigate('/login');
    } else {
      const decodedToken = jwtDecode(isToken);
      const currentTime = Date.now() / 1000;
      // if(!decodedToken.iat) {
      //   localStorage.removeItem('token');
      //   navigate('/login');
      // }
      // if (decodedToken.iat < currentTime) {
      //   localStorage.removeItem('token');
      //   navigate('/login');
      // }
    }
  }, [navigate, isToken]);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });
    const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);


    const configsButton = (
      <SoftBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="3.5rem"
        height="3.5rem"
        bgColor="#2c2c2c" // Dark background color
        shadow="sm"
        borderRadius="50%"
        position="fixed"
        right="2rem"
        bottom="2rem"
        zIndex={99}
        color="#ffffff" // White or light color for the icon
        sx={{
          cursor: "pointer",
          boxShadow: "0px 4px 8px 0px rgba(255, 255, 255, 0.3)", // White shadow below
        }}
        onClick={handleConfiguratorOpen}
        
      >
        <Icon fontSize="default" color="inherit">
          settings
        </Icon>
      </SoftBox>
    );
    


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={'info'}
            brand={brand}
            brandName="Thali App"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />

          {/* {
            pathname == "/profile"&&
          (
            <>
            <Configurator/>
            {configsButton}
            </>
          )
         } */}
        </>
      )}
      
      <Routes>
        {getRoutes(routes)}
        <Route path="/register" element={<SignUp/>} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
     
    </ThemeProvider>
  );
}
